import { createSlice } from '@reduxjs/toolkit';
import { NavBarLinks } from "./NavBarLinks";

const mainSlice = createSlice({
    name: 'main',
    initialState: NavBarLinks,
    reducers: {
        addItem: (state, action) => {
            state.push(action.payload);
        },
    },
});

export const { addItem } = mainSlice.actions;
export default mainSlice;